import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import TMTITable from "components/tenant-market/ti/tm-ti-table"
// Data
import api_match from "data/interface/api"
import tenantcapitalService from "data/tenant-capital"
import propertyService from 'data/property.ts'
import importService from "data/import"
import inflationService from "data/inflation"
import payoutService from "data/payout"
import { alphanum } from "components/table/lib/sort"
//Styles
import { TMTI_s } from "components/tenant-market/ti/tm-ti-styles"
import { AddIcon } from "images/icons/tools"

const TMTI: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [inflation, setInflation] = useState<object[]>([])
  const [payout, setPayout] = useState<object[]>([])
  const tableId = "tm-ti-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const tenantcapitalSubscription = tenantcapitalService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const property = _.find(data.value, {propertyid: data.current});
        setProperty(property)
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation(ok.value)
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const payoutSubscription = payoutService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPayout(init.value),
        ok    => {
          setPayout(ok.value)
        },
        err   => {
          setPayout(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      tenantcapitalSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      inflationSubscription.unsubscribe()
      payoutSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    tenantcapitalService.fetchTenantcapital(propertyId, "ti")
    propertyService.fetchProperty(propertyId)
    inflationService.fetchInflation(propertyId)
    payoutService.fetchPayout(propertyId)

  }, [propertyId])

  const Add = () => {
    const defaults = property ? {...property['defaultsnameditem']} : {}
    return (
      <a onClick={() => tenantcapitalService.create(propertyService.getStoredPropertyId(), defaults, "ti")}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TMTI_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="ti" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && inflation && !showImport &&
      <TMTITable
        tableId={tableId}
        data={data}
        inflationData={inflation}
        payoutData={payout}
        defaults={{...property['defaultsnameditem']}} /> }
    </TMTI_s>
  )
}

export default TMTI
